app.controller(
    'ConsultationWalkController', ['$scope', '$rootScope', '$sce', '$http', '$stateParams', '$state', 'FlaneriesService', '$translate', ConsultationWalkController]
);


function ConsultationWalkController($scope, $rootScope, $sce, $http, $stateParams, $state, FlaneriesService, $translate) {

    $scope.edit = {
        etapes: {}
    };

    $scope.client = {
        name: 'Art et architecture',
        sousTitre: 'Les passages couverts',
        titreDesc: 'Galerie Vivienne',
        sousTitreDesc: 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
        resumeDesc: 'résumé',
        txtDesc: 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.',
        clients: [
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
        ],
        diffuseurs: [
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
        ],
        classifications: [
            {
                name: 'Art moderne',
                checked: true
            },
            {
                name: 'Haute époque',
                checked: true
            },
            {
                name: 'Art moderne',
                checked: true
            },
            {
                name: 'Haute époque',
                checked: true
            },
            {
                name: 'Art moderne',
                checked: false
            },
            {
                name: 'Haute époque',
                checked: false
            },


        ]
    };

    $scope.contentTranslate = null;

    $scope.planning = {
        etapes: [
            {
                'nameEtape': 'Étape 1',
                'schedule': 'Nom de l\'étape',
                'heureH': '8',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Galerie Valois',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 2',
                'schedule': '',
                'heureH': '9',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Passage des deux-pavillons',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 3',
                'schedule': '',
                'heureH': '10',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Galerie Vivienne',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 4',
                'schedule': '',
                'heureH': '11',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Passage Jouffroy',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 5',
                'schedule': '',
                'heureH': '12',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Passage Verdeau',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            }
        ],
        diffuseurs: [
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
        ]
    };

    $scope.newDescriptifClient = function () {

        for (var i = 0; i < $scope.client.diffuseurs.length; i++) {
            $scope.client.diffuseurs[i].checked = false;
        }
        for (var i = 0; i < $scope.client.clients.length; i++) {
            $scope.client.clients[i]['checked'] = false;
        }
        for (var i = 0; i < $scope.planning.diffuseurs.length; i++) {
            $scope.planning.diffuseurs[i]['checked'] = false;
        }
    };

    $scope.addStep = function () {
        $scope.planning.etapes.push({
            nameEtape: null,
            schedule: null,
            heureH: null,
            heureM: null,
            dureeH: null,
            dureeM: null,
            titre: null,
            sousTitre: null,
            description: null,
            openDropdown: true,
            edition: true
        });
    }


    $scope.removeStep = function (step) {
        $scope.vm.ItineraryStepList.splice(step, 1);
    };

    //strat
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    if ($stateParams.id) {
        vm.ParamBioId = $stateParams.id;
    }
    else {
        vm.ParamBioId = $rootScope.DefaultGlobalZoneId;
    }
    $translate.use($rootScope.LangForInterface);

    //load place
    $scope.vm = {};

    var FlaneriesGetSingle = FlaneriesService.getFlaneries($stateParams.id, $stateParams.lang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse, $stateParams.filter, $stateParams.countryId, $stateParams.CityId, $stateParams.UpdateDate, $stateParams.CreationDate, $stateParams.statusId, $stateParams.clid, $stateParams.langCode, $stateParams.Duration);
    FlaneriesGetSingle.then(function (t) {
        var res = t.data;
        $scope.vm = res;
        $rootScope.SideBar = res.SideBar;
        $rootScope.Clients = res.ClientList;
        $rootScope.ClassificationList = res.ClassificationList

        $rootScope.CurrentObjectId = $stateParams.id;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.Itinerary;
        $rootScope.CurrentObjectStatus = res.CurrentItineraryStatus;
        $rootScope.SideBar.CurrentObjectStatus = $rootScope.CurrentObjectStatus
        $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;

        //$scope.ChangeZoneById(vm.ParamZoneId);
    },
    function (e) {
        console.log('Chargement du lieu impossible', e);
    });

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };




    $scope.UpdateItineraryTranslation = function UpdateItineraryTranslation() {

        FlaneriesService.UpdateItineraryTranslation($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;

            } else {
                console.log("error: ");
            }
        });
    };

    $scope.UpdateItineraryStepTranslation = function UpdateItineraryStepTranslation(vm, index) {

        FlaneriesService.UpdateItineraryStepTranslation(vm, index, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;

            } else {
                console.log("error: ");
            }
        });
    };



    $scope.UpdateDescription = function UpdateDescription() {

        FlaneriesService.UpdateDescriptionIti($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;
            } else {
                console.log("error: ");
            }
        });
    };





    $scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {

        if (index == 0)
            $scope.vm.CurrentDescription.Description.StatusId = status;
        else
            $scope.vm.DescriptionList[index].Description.StatusId = status;
        FlaneriesService.UpdateDescriptionStatusIti($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;
            } else {
                console.log("error: ");
            }
        });
    };


    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $stateParams.lang, $rootScope.EnumLinkType.Itinerary);
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareItineraryPracticalInfo', $translate.instant('emailShareItineraryPracticalInfo').replaceAll('&amp;', '&'), $scope.vm);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
}